import React from "react";
import { Container, Box, Card, Typography } from "@mui/material";
import SchoolIcon from "@mui/icons-material/School";
import SectionHeading from "./SectionHeading";
import useReveal from "./useReveal";
import { brand } from "../theme";

const campus = [
  "Muthayammal Engineering College, Namakkal",
  "Kalasalingam University, Krishnan Kovil",
  "Sapthagiri Engineering College, Bangalore",
  "Saveetha Engineering College, Chennai",
  "SRM Valliammai Engineering College, Chennai",
  "Rajiv Gandhi College of Engineering & Technology, Puducherry",
  "Christ College of Engineering & Technology, Puducherry",
  "Kamaraj College of Engineering & Technology, Virudhunagar",
  "Mepco Schlenk Engineering College, Sivakasi",
  "K Ramakrishnan College of Engineering, Trichy",
  "C Abdul Hakeem College of Engineering & Technology, Vellore",
  "KSR Institution, Tiruchengode",
  "Mahendra Engineering College for Women, Tiruchengode",
  "Bharathiyar Engineering College for Women, Thalaivasal",
  "AVS Engineering College, Salem",
  "Bharath University, Chennai",
  "Bannari Amman Institute of Technology, Sathyamangalam",
  "Builders Engineering College, Erode",
  "National Engineering College, Kovilpatti",
  "SDM Institute of Technology, Ujire, Karnataka",
  "Vignan Institute of Information Technology, Vishakapatnam",
  "Sri Venkatesa Perumal Engineering & Technology, Puttur",
  "Mangalore Institute of Technology & Engineering, Karnataka",
  "N.M.A.M. Institute of Technology, Nitte, Udupi, Karnataka",
];

const half = Math.ceil(campus.length / 2);
const rowOne = campus.slice(0, half);
const rowTwo = campus.slice(half);

const CampusChip = ({ name }) => (
  <Card
    elevation={0}
    sx={{
      flexShrink: 0,
      width: { xs: 220, md: 280 },
      minHeight: 96,
      p: 2.5,
      display: "flex",
      alignItems: "center",
      gap: 1.5,
      bgcolor: "#fff",
      border: "1px solid rgba(12,131,200,0.10)",
      transition: "transform .25s ease, box-shadow .25s ease, border-color .25s ease",
      "&:hover": {
        transform: "translateY(-4px)",
        boxShadow: "0 14px 32px rgba(15,39,64,0.12)",
        borderColor: brand.blue,
        "& .campus-icon": { color: brand.orange, transform: "rotate(-8deg) scale(1.1)" },
      },
    }}
  >
    <Box
      sx={{
        flexShrink: 0,
        width: 44,
        height: 44,
        borderRadius: "12px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "rgba(12,131,200,0.10)",
      }}
    >
      <SchoolIcon
        className="campus-icon"
        sx={{ color: brand.blue, fontSize: 24, transition: "color .25s ease, transform .25s ease" }}
      />
    </Box>
    <Typography sx={{ color: brand.navy, fontSize: "0.84rem", fontWeight: 600, lineHeight: 1.35 }}>
      {name}
    </Typography>
  </Card>
);

const MarqueeRow = ({ items, direction }) => (
  <Box className="marquee" sx={{ py: 1.5 }}>
    <Box className={`marquee__track marquee__track--${direction}`}>
      {/* Duplicated once for a seamless infinite loop */}
      {[...items, ...items].map((name, i) => (
        <CampusChip key={`${direction}-${i}`} name={name} />
      ))}
    </Box>
  </Box>
);

const CampusCard = () => {
  const ref = useReveal();
  return (
    <section id="campus-section" className="campus-section" ref={ref}>
      <Box sx={{ py: { xs: 7, md: 11 }, bgcolor: brand.bgAlt, overflow: "hidden" }}>
        <Container>
          <SectionHeading
            eyebrow="ACADEMIC FOOTPRINT"
            title="Campuses Our Experts Have Served"
            subtitle="A long-term academic MoU with Muthayammal Engineering College anchors a growing network of institutional partnerships across South India."
          />
        </Container>

        {/* Full-bleed marquees — two rows gliding in opposite directions */}
        <Box className="reveal" sx={{ mt: 2 }}>
          <MarqueeRow items={rowOne} direction="left" />
          <MarqueeRow items={rowTwo} direction="right" />
        </Box>
      </Box>
    </section>
  );
};

export default CampusCard;
